import { useCallback } from "react";
import { useApp } from "@/state/AppContext";
import { promptSignIn } from "@/lib/signInPrompt";

/**
 * `const requireAuth = useRequireAuth();` then, at the top of any mutating handler:
 * `if (!requireAuth()) return;` — true when signed in; otherwise opens the sign-in prompt and
 * returns false so the caller makes no request and keeps whatever the person typed (UAT L2).
 *
 * The prompt returns the guest to `next` if given, else to the page they are on (the prompt itself
 * lives inside the router and reads the location, so this hook needs no router context).
 */
export function useRequireAuth() {
  const { auth } = useApp();
  return useCallback(
    (next) => {
      if (auth) return true;
      promptSignIn(next);
      return false;
    },
    [auth],
  );
}
